import { Component, h, Host, Prop } from '@stencil/core';
import { figureConfigurations } from "./figure-data";

@Component({
  tag: 'lk-figure'
})
export class Figure {

  @Prop() figureName: string = "figure2";
  @Prop() rotate: boolean = false;
  @Prop() half: boolean = false;

  @Prop() leftColor: string = "#f07850";
  @Prop() rightColor: string = "#f0c8a0";
  @Prop() backgroundColor: string = "#3c78b4";
  @Prop() height: any = "250";
  @Prop() width: any = "250";

  render() {
    const options = figureConfigurations[this.figureName];
    return (
      <Host>
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" role="presentation" x="0px" y="0px" viewBox={this.half ? "0 0 250 500" : "0 0 500 500"} >
          <g transform={this.rotate ? "rotate(-90, 250, 250)" : ""}>
            <rect width="100%" height="100%" fill={options.backgroundColor} />
            <path fill={options.leftColor} d={options.leftPath} />
            <path fill={options.rightColor} d={options.rightPath} />
          </g>
        </svg>
      </Host>
    );
  }
}
